import { isDarkColor } from "@/utils/color";

export interface ButtonCreatorConfig {
  backgroundType?: string;
  buttonColor?: string;
  buttonLabel?: string;
  compareType?: string;
  crop?: {
    x?: string;
    y?: string;
    height?: string;
    width?: string;
  };
  designType?: string;
  threshold?: string;
  url?: string;
}

export const createWidgetUiPayload = (options?: ButtonCreatorConfig) => {
  const buttonTextColor = isDarkColor(options?.buttonColor) ? "#ffffff" : "#111111";

  const crop = `${options?.crop?.x}_${options?.crop?.y}_${options?.crop?.width}_${options?.crop?.height}`;

  return `<div id="visualping_widget" data-label="${options?.buttonLabel}" data-mode="${options?.designType}" data-bg="${options?.backgroundType}" data-btn="${options?.buttonColor},${buttonTextColor}" data-trigger="${options?.threshold}" data-compare="${options?.compareType}" data-crop="${crop}"></div><script src="https://visualping.io/externalfiles/widget/vp.min.js"></script>`;
};

export const createWidgetLinkPayload = (options?: ButtonCreatorConfig) => {
  const crop = `${options?.crop?.x}_${options?.crop?.y}_${options?.crop?.width}_${options?.crop?.height}`;
  const href = `https://visualping.io/?url=${btoa(options?.url ?? "")}&mode=${
    options?.compareType
  }&sref=uwgt&wid=zzz&trigger=${options?.threshold}&precrop=${crop}`;

  return `<a href="${href}" style={{ fontWeight: "bold", textDecoration: "underline", color: ${options?.buttonColor}}}>${options?.buttonLabel}</a>`;
};
